export const Since = ({ from }) =>
  new Date().getFullYear() - new Date(from).getFullYear()
